import React, {Component} from "react";
import {map, isEmpty} from 'lodash';

import BasicDetail from "./BasicDetail";
import SideBar from "./SideBar";
import Header from "../../../Common/Component/Header";
import Sidebar from "../../../Common/Component/Sidebar";
import Loader from "../../../Common/Component/Loader";

const contactUsData = [
  {
    id: 'industry_association',
    name: 'Industry Association',
    value: 'industry association'
  },
  {
    id: 'referral',
    name: 'Referral',
    value: 'referral'
  },
  {
    id: 'networking_event',
    name: 'Networking Event',
    value: 'networking event'
  },
  {
    id: 'presentation',
    name: 'Presentation',
    value: 'presentation'
  },
  {
    id: 'internet_search',
    name: 'Internet Search',
    value: 'internet search'
  },
  // {
  //   id: 'advertisement',
  //   name: 'Advertisement',
  //   value: 'advertisement'
  // },
  {
    id: 'other',
    name: 'Other',
    value: 'other'
  },
]
class DogInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      franchises: [],
      zipcode: '',
      zipcodeCheck: null,
      doggy_door: true,
      dog_outside: true,
      can_clean: false,
      pets: [],
      contactUs: [],
      serviceOrder: {},
      is_basic_btn_active: false,
      about_your_dogs: '',
      hear_about_us: []
    }
  }

  componentDidMount = () => {
    let {pets} = this.state;
    const {history} = this.props;
    const {id, zipcode} = history?.location?.state?.query;
    const step1 = JSON.parse(sessionStorage.getItem("step1"));

    if (id) {
      if(step1)
      {

        for (let i = 0; i < step1?.dogCount; i++) 
        {
          pets.push({
            name: '',
            breed: '',
            birthday: null,
            is_friendly: false,
            can_treat: false,
            additional_info: '',
            photo: ''
          });
        }

        if(step1?.is_extra_pet)
        {
          for (let i = 0; i < step1?.extra_pet; i++) 
          {
            pets.push({
              name: '',
              breed: '',
              birthday: null,
              is_friendly: false,
              can_treat: false,
              additional_info: '',
              photo: ''
            });
          }
        }

        this.setState({ pets }, () => this.priceCalc());
      }

      this.setState({loader: true, zipcode});
      setTimeout(() => {
        this.props.getCustomerDetail(id) // get customer detail
        this.props.getServiceOrder({user__uuid: id, limit: 1}) // get service order
        this.props.checkZipCode({addressable_zip_codes__contains: zipcode, close: false}); // check zip code
      }, 2000);
      setTimeout(() => this.setState({loader: false}), 3000);
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    let {pets, serviceOrder} = this.state;

    // check zipcode
    if (Object.keys(nextProps?.ZipcodeCheck?.data).length > 0 && nextProps?.ZipcodeCheck?.data?.results?.length > 0) {
      this.setState({zipcodeCheck: true, franchises: nextProps?.ZipcodeCheck?.data?.results});
    } else {
      this.setState({zipcodeCheck: false, franchises: []});
    }

    // get customer detail
    if (Object.keys(nextProps?.CustomerList?.customer).length > 0) {
      this.setState({ customer: nextProps?.CustomerList?.customer });
    }

    // get service order
    if (Object.keys(nextProps?.ServiceOrder?.data).length > 0 && 
      Object.keys(nextProps?.ServiceOrder?.data?.results)?.length > 0) 
    {
      serviceOrder = nextProps?.ServiceOrder?.data?.results?.[0];
      if (JSON.stringify(nextProps?.ServiceOrder?.data?.results?.[0]) !== JSON.stringify(this.state.serviceOrder)) 
      {
        if(pets.length === 0)
        {
          for (let i = 0; i < serviceOrder?.pet_count; i++) 
          {
            pets.push({
              name: '',
              breed: '',
              birthday: null,
              is_friendly: false,
              can_treat: false,
              additional_info: '',
              photo: ''
            });
          }

          this.setState({ serviceOrder, pets }, () => this.priceCalc());
        }
        else
          this.setState({ serviceOrder }, () => this.priceCalc());
      }
    }
  }

  // common Price Calc
  priceCalc = () => {
    const {franchises, serviceOrder} = this.state;
    if (!isEmpty(serviceOrder)) {
      this.setState({loader: true})
      const service_add_ons = serviceOrder?.recurring_add_ons?.recurring_addon_items?.map(
        obj => ({uuid: obj?.uuid, add_on_name: obj?.name, is_recurring: obj?.is_recurring || false}));
      const data = {
        'field_office_uuid': franchises?.[0]?.uuid,
        'frequency': serviceOrder?.calculated_price?.frequency,
        'pet_count': serviceOrder?.calculated_price?.pet_count,
        'last_cleaned': serviceOrder?.last_cleaned,
        'property_type': serviceOrder?.calculated_price?.property_type,
        'areas_to_clean': serviceOrder?.calculated_price?.area_to_clean,
        'add_ons': service_add_ons,
        'is_prepaid': serviceOrder?.is_prepaid,
        'prepay_months': serviceOrder?.is_prepaid ? serviceOrder?.prepay_months : null
      }

      if (serviceOrder?.coupon_code) Object.assign(data, {'coupon_code': serviceOrder?.coupon_code});
      this.props.pricingCalculator(data);
      setTimeout(() => this.setState({loader: false}), 1000);
    }
  }

  // validate basic detail
  validateBasicInfo = (value) => {
    const {is_basic_btn_active} = this.state;
    if (is_basic_btn_active !== value) {
      this.setState({is_basic_btn_active: value})
    }
  }

  // on safety detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value })
  }

  // get base 64 string
  getBase64String = (file = {}, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function () {
      cb(reader.result);
    }
  };

  // Dog Profile pic upload
  // onDogImagesChange = (e, i) => {
  //   const {pets} = this.state;
  //   let file = e?.target?.files?.[0];
  //   if (file?.size > (5 * 1048576)) {
  //     message.error('Image size should be less than 5MB');
  //   } else {
  //     file && this.getBase64String(file, (result) => {
  //       Object.assign(pets[i], {photo: result});
  //       this.setState({pets})
  //     });
  //   }
  // };

  // set Dog details
  onPetChange = (e, i) => {
    const {pets} = this.state;
    Object.assign(pets[i], {[e.target.name]: e.target.value});
    this.setState({pets});
  }

  // on Delete pet detail
  onDelete = (index) => {
    const {pets} = this.state;
    pets[index]['name'] = ''
    pets[index]['breed'] = ''
    pets[index]['birthday'] = null
    pets[index]['additional_info'] = ''
    pets[index]['photo'] = ''
    pets[index]['is_friendly'] = false
    pets[index]['can_treat'] = false
    this.setState({pets})
  }

  // on hear about us change
  onHearAboutChange = (value) => {
    const {contactUs} = this.state;
    const idx = contactUs.indexOf(value);

    if (idx > -1) {
      contactUs.splice(idx, 1);
    } else {
      contactUs.push(value);
    }
    this.setState({contactUs});
  }

  onSaveCustomer = () => {
    const {
      doggy_door,
      dog_outside,
      can_clean,
      pets,
      serviceOrder,
      about_your_dogs,
    } = this.state;
    this.props.updateServiceOrder({
      uuid: serviceOrder?.uuid,
      has_doggy_door: doggy_door,
      is_dogs_outside: dog_outside,
      can_clean_if_dogs_out: can_clean,
      pets,
      hear_about_us:serviceOrder.hear_about_us,
      about_your_dogs,
      area_to_clean:serviceOrder.area_to_clean,
      phone_numbers:serviceOrder.phone_numbers,
      service_add_ons:serviceOrder.service_add_ons
    })
    setTimeout(() => this.props.history.replace('/residential'), 1000)
  }

  onCancel = () => {
    this.props.history.replace('/residential');
    sessionStorage.removeItem('basicDetail');
    sessionStorage.removeItem('step1');
    sessionStorage.removeItem('step2');
    sessionStorage.removeItem('calcData');
    sessionStorage.removeItem('pricingCalc');
    sessionStorage.removeItem('logCall');
  }

  //render pet details
  renderDogDetail = () => {
    const {pets} = this.state;

    return map(pets, (item, index) => 
    {
      return <React.Fragment>
        <div key={`pet${index}`} className="flex-1 dog-col">
          <div className="fitem">          
            <input type="text"           
              placeholder="Dog Name"
              value={item.name}
              onChange={(e) => { this.onPetChange(e, index) }}
              name={'name'} />
            {/* <img src={trash}
              alt=""
              className="delete_dod_info"
              onClick={() => this.onDelete(i)}
            /> */}
          </div>       
          <div className="fitem">
            <input type="text"          
              placeholder="Breed"
              name={'breed'}
              value={item.breed}
              onChange={(e) => { this.onPetChange(e, index) }}
            />
          </div>
          <div className="fitem">
            <input type="text"          
              placeholder="Additional Information"
              name={'additional_info'}
              value={item.additional_info}
              onChange={(e) => { this.onPetChange(e, index) }}
            />
          </div>

          {/* <div className="fitem">          
            <DatePicker             
              format="MM/DD/YYYY"
              inputReadOnly
              value={item['birthday'] && moment(item['birthday'])}
              onChange={(e) => this.onPetChange({target: {name: 'birthday', value: e?.format('YYYY-MM-DD')}}, i)}
              name={'birthday'}
              allowClear={false}
              dropdownClassName="dog_date_dropdown"
              placeholder="Birthday MM/DD/YYYY" />
  
  
            {item['photo'] ?
              <div className="dog_image">
                <img src={item['photo']} className="profile_pic " alt="" />
                <i className="las la-times-circle remove_images" onClick={() => this.onPetChange({target: {name: 'photo', value: ''}}, i)}/>
              </div>
              :
              <React.Fragment>
                <div className="upload-btn-wrapper">
                  <button className="upload_btn"><img src={Upload_Photo} alt="" /></button>
                  <input type="file" name={'photo-' + i} onChange={(e) => { this.onDogImagesChange(e, i) }} />
                </div>
              </React.Fragment>
            }        
          </div> */}
          
          <b className="d-block mt-30 mb-10">Dog Information</b>
          <div className="inline-check-list gcheck">
            <div className="fitem-check">
              <input id={'is_friendly' + index} type="checkbox"
                checked={item['is_friendly']}
                onChange={(e) => this.onPetChange({target: {name: 'is_friendly', value: e.target.checked}}, index)}
                className="fitem-ck-input"
              />
              <label htmlFor={'is_friendly' + index} className="fitem-ck-txt">Yes, this dog is friendly.</label>
            </div>
            <div className="fitem-check">
              <input id={'can_treat' + index}
                type="checkbox"
                checked={item['can_treat']}
                onChange={(e) => this.onPetChange({target: {name: 'can_treat', value: e.target.checked}}, index)}
                className="fitem-ck-input"
              />
              <label htmlFor={'can_treat' + index} className="fitem-ck-txt">Yes, we can give this dog a treat.</label>
            </div>
          </div>
          <hr/>
        </div>
      </React.Fragment>
    });
  }

  //render hear about us
  renderContactUs = (item, index) => {
    const { contactUs } = this.state;
    const isSelected = contactUs?.indexOf(item.value) > -1;

    return (
      <div className="inline-checks" key={`contactUs${index}`}>
        <label htmlFor={item?.value} className={isSelected ? 'active' : ''}>
          <input type="checkbox" id={item?.id} name="contactUs" className="" value={item?.value} onChange={() => this.onHearAboutChange(item?.value)}/>
          <span>{item?.name}</span>
        </label>
      </div>
    )
  };

  render() {
    const {
      zipcodeCheck,
      doggy_door,
      dog_outside,
      can_clean,
      pets,
      loader,
      is_basic_btn_active,
      about_your_dogs,
      hear_about_us
    } = this.state;

    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header
            placeholder="Search for a ticket by client name, subject or keyword"
          />

          {/* Sidebar */}
          <Sidebar />
          <div className="fluid">
            {loader && <Loader />}
            <div className="container">
              <div className="fluid-block">
                <div className="article-block">
                  <BasicDetail
                    zipcode={this.props.zipcode}
                    zipcodeCheck={this.props.ZipcodeCheck}
                    customerList={this.props.CustomerList}
                    validateBasicInfo={this.validateBasicInfo}
                    changeInfo={true}
                  />
                  <div className={`adetail ${zipcodeCheck ? '' : 'disabled'}`}>
                    <h3>Safety Information</h3>
                    <div className="form-group">
                      <div className="frow">
                        <h4>Tell us about your dogs</h4>
                        <div className="inline-check-list">
                          <div className="flex mb-10 ai-center">
                            <h4 className="m-0">Is there a doggy door?</h4>
                            <div className="chk_switch">
                              <div className="can-toggle can-toggle--size-small">
                                <input id="doggy_door" type="checkbox" name={"doggy_door"} checked={!doggy_door} onChange={(e) => { this.onTextChange({target: {name: 'doggy_door', checked: !e.target.checked}}, 'bool') }} />
                                <label htmlFor="doggy_door">
                                  <div className="can-toggle__switch"
                                    data-unchecked="Yes"
                                    data-checked="No"
                                  />
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="flex mb-10 ai-center">
                            <h4 className="m-0">Are your dogs left outside when none is home?</h4>
                            <div className="chk_switch">
                              <div className="can-toggle can-toggle--size-small">
                                <input id="dog_outside" type="checkbox" name={"dog_outside"} checked={!dog_outside} onChange={(e) => { this.onTextChange({target: {name: 'dog_outside', checked: !e.target.checked}}, 'bool') }} />
                                <label htmlFor="dog_outside">
                                  <div className="can-toggle__switch"
                                    data-unchecked="Yes"
                                    data-checked="No"
                                  />
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="flex mb-10 ai-center">
                            <h4 className="m-0">Can we clean with your dogs outside?</h4>
                            <div className="chk_switch">
                              <div className="can-toggle can-toggle--size-small">
                                <input id="can_clean" type="checkbox" name={"can_clean"} checked={!can_clean} onChange={(e) => { this.onTextChange({target: {name: 'can_clean', checked: !e.target.checked}}, 'bool') }} />
                                <label htmlFor="can_clean">
                                  <div className="can-toggle__switch"
                                    data-unchecked="Yes"
                                    data-checked="No"
                                  />
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-30 dogs-form">
                        <h4>{"Is there anything else we should know about your dogs?"}</h4>
                        <div className="flex flex-wrap">                        
                          <textarea className="form--control text-area--control"
                            value={about_your_dogs}
                            name="about_your_dogs" rows="5" cols="50"
                            placeholder="More about your Dogs"
                            onChange={(e) => this.setState({about_your_dogs: e.target.value})} />
                        </div>
                      </div>
                      <div className="mt-30 dogs-form">
                        <h4>About their dogs (optional)</h4>
                        <div className="flex flex-wrap">
                          {
                            this.renderDogDetail()
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <SideBar
                  PricingCalc={this.props.PricingCalc}
                  serviceOrder={this.props.ServiceOrder}
                />
              </div>
              <div className="fix-btn-grp">
                <button
                  className="btn btn-white"
                  onClick={() => this.onCancel()}
                >
                  Cancel
                </button>
                <button
                  className={`btn ${is_basic_btn_active ? 'btn-warning' : 'disabled'}`}
                  onClick={() => this.onSaveCustomer()}
                >
                  Save New Customer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DogInfo;